export class DecodeHtmlEntity {
    static fromString(textWithHtmlEntities : string) {        
        var txt = document.createElement('textarea');
        txt.innerHTML = textWithHtmlEntities;
        return txt.value;
    }
}